function splitArrayInChunks(array, size) {
  return array.reduce((acc, curr, i) => {
    const index = Math.floor(i / size);
    if (!acc[Number(index)]) {
      acc[Number(index)] = [];
    }
    acc[Number(index)].push(curr);
    return acc;
  }, []);
}
export {
  splitArrayInChunks as default
};
